<template>
    <div></div>
</template>
<script setup lang="ts">
// Empty renderer for an ag cell that shouldn not render anything.
// Typically this will be used for checkbox columns where the grid renders the checkboxes.
// TODO: The grid should never control the cell content, so we shouldnt let the grid render the checkboxes.
</script>
